import {
  UPDATE_FAVORITES_MUSIC_LIST,
  ADD_FAVORITES_MUSIC_LIST
} from '../../actions/musica/music-actions';


const initialState = {
  items: []
};


const updateList = (state, action) => {
  const currentContent = action.items;
  return {
    items: [...currentContent]
  };
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_FAVORITES_MUSIC_LIST:
      return updateList(state, action);
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/musica/favorites.js